import React from "react";
import { IconType } from "react-icons";
import {
  FaThLarge,
  FaMagic,
  FaVial,
  FaSyncAlt,
  FaFilePowerpoint,
  FaShareAlt
} from "react-icons/fa";
type FeatureItem = {
  icon: IconType; 
  heading: string;
  info: string;
};
const KeyFeaturesSection = () => {
 const features: FeatureItem[] = [
  {
    icon: FaThLarge,
    heading: "Proven Frameworks & Layouts",
    info: "Create slides based on structured and business-ready layouts.",
  },
  {
    icon: FaMagic,
    heading: "AI-Powered Slide Generation",
    info: "Full AI decks with content, visuals, and structure tailored to your input.",
  },
  {
    icon: FaVial,
    heading: "Brand Sync",
    info: "Automatically apply logos, colors, fonts, and styling across all slides.",
  },
  {
    icon: FaSyncAlt,
    heading: "Real-Time Google Slides Sync",
    info: "Powered by Google - edit your deck in Google Slides with a two-way sync.",
  },
  {
    icon: FaFilePowerpoint,
    heading: "PowerPoint Compatibility",
    info: "Download your deck as a fully editable PowerPoint presentation (PPTX).",
  },
  {
    icon: FaShareAlt,
    heading: "Seamless Sharing",
    info: "Share your AI-generated presentation with a public or private weblink.",
  },
];


  return (
    <div className="bg-white mb-14  mt-12">
      <div className="flex flex-col items-center justify-center mb-8 ">
        <h1 className=" text-4xl font-bold text-gray-900 z-10">
          Key Features of Our AI
        </h1>
        <h1 className="  text-4xl font-bold text-gray-900 z-10">
          Presentation Platform
        </h1>
      </div>
      <div className="flex justify-center w-full">
        <div className="w-[80%] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-2 py-1">
          {features.map((feature, index) => (
           <div key={index} className="flex flex-col rounded-md border border-gray-200 p-8">

              <div className="text-3xl mb-4">
                <feature.icon className="text-3xl  mb-4" />
              </div>
              <h3 className="text-lg font-semibold mb-2">{feature.heading}</h3>
              <p className="text-gray-600">{feature.info}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KeyFeaturesSection;
